import { curry } from 'ramda';

const makeKey = curry((key, session) => `drsa:${session}:${key}`);

const AUTH_KEY = 'auth';
const makeAuthKey = makeKey(AUTH_KEY);

const CLAIM_KEY = 'claim';
const makeClaimIdKey = makeKey(CLAIM_KEY);
const makeClaimKey = id => `drsa:${CLAIM_KEY}:${id}`;

const MISSION_KEY = 'mission';
const makeMissionIdKey = makeKey(MISSION_KEY);

const JWT_KEY = 'jwt';
const makeJwtKey = makeKey(JWT_KEY);

const IS_TIMELINE_CONFIRMED = 'isTimeLineConfirmed';
const isTimeLineConfirmed = makeKey(IS_TIMELINE_CONFIRMED);

export const APP_STATE = 'APP_STATE';

const setItem = (key, value) => sessionStorage.setItem(key, JSON.stringify(value));
const getItem = key => {
  const value = sessionStorage.getItem(key);
  return value && JSON.parse(value);
};

export const setAuth = (session, auth) => setItem(makeAuthKey(session), auth);
export const getAuth = session => getItem(makeAuthKey(session));

export const setClaimId = (session, { id }) => setItem(makeClaimIdKey(session), id);
export const getClaimId = session => getItem(makeClaimIdKey(session));

export const storeClaim = claim => setItem(makeClaimKey(claim.id), claim);
export const loadClaim = id => getItem(makeClaimKey(id));

export const setMissionId = (session, { id }) => setItem(makeMissionIdKey(session), id);
export const getMissionId = session => getItem(makeMissionIdKey(session));

export const setJwt = (session, jwt) => setItem(makeJwtKey(session), jwt);
export const getJwt = session => getItem(makeJwtKey(session));

export const setIsTimeLineConfirmed = (session, isConfirmed) => setItem(isTimeLineConfirmed(session), isConfirmed);
export const getIsTimeLineConfirmed = session => getItem(isTimeLineConfirmed(session));
